/**
 * Reports API functions.
 */

import apiClient from './client';
import type { ReportRequest, ReportResponse, ReportDetailResponse } from './types';

export async function generateReport(request: ReportRequest): Promise<ReportResponse> {
  const response = await apiClient.post('/cti/reports', request);
  return response.data;
}

export async function getReport(reportId: string): Promise<ReportDetailResponse> {
  const response = await apiClient.get(`/cti/reports/${reportId}`);
  return response.data;
}
